// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"500":"7b0b7e05","715":"80454c38"}[chunkId] + ".chunk.css";
};